'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var RESOURCE_ACTION_TYPES = exports.RESOURCE_ACTION_TYPES = {
    RESOURCE_FETCH: 'RESOURCE_FETCH',
    RESOURCE_FETCH_ERROR: 'RESOURCE_FETCH_ERROR',
    RESOURCE_FETCH_SUCCESS: 'RESOURCE_FETCH_SUCCESS'
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/static/staticResourceConstants.js
// module id = 717
// module chunks = 0